import accountantService from 'ApiService/Admin/accountantService';
import GenericUserList from '../../../List/GenericUserList';
import { useContext } from 'react';
import { AuthContext } from 'contexts/AuthContext';

const AccountantList = () => {
  const { state } = useContext(AuthContext);
  const userRole = state?.user?.role;

  const columns = [
    { header: 'Accountant Name', key: 'name' },
    { header: 'Email', key: 'email' },
    // { header: 'Gender', key: 'gender' },
    // { header: 'Date of Birth', key: 'dob' },
    // { header: 'Institute ID', key: 'instituteId' },
    ...(userRole === 'superadmin'
      ? [
          { header: 'Branch', key: 'branchName' },
          { header: 'Location', key: 'branchLocation' },
        ]
      : []),
    { header: 'Contact No', key: 'contact' },
  ];

  const fetchTeachers = async (userId, page) => {
    return await accountantService.getAllAccountant(userId, page);
  };

  const updateTeacher = async (data) => {
    return await accountantService.updateAccountant(data);
  };

  return (
    <GenericUserList
      fetchUsers={fetchTeachers}
      updateUser={updateTeacher}
      userType="Accountant"
      columns={columns}
    />
  );
};

export default AccountantList;
